import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'g10-roster-dashboard-vehicle',
  templateUrl: './roster-dashboard-vehicle.component.html',
  styleUrls: ['./roster-dashboard-vehicle.component.css']
})
export class RosterDashboardVehicleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
